module.exports = __webpack_public_path__ + "d94e20c1/img/link-icon.fa09ed66.svg";